import React, { useEffect, useState } from 'react'
import Grid from '../../../molecules/Grid'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import schemaReportForm from '../../../../core/schemes/schemaReportForm.js'
import TextField from '../../../atoms/UI/forms/TextField/TextField'
import Button from '../../../atoms/UI/buttons/Button'
import Radio from '../../../atoms/UI/forms/Radio/Radio'
import Textarea from '../../../atoms/UI/forms/Textarea/Textarea'
import {useDispatch, useSelector} from 'react-redux'
import SuccessMessage from '../../../atoms/UI/forms/SuccessMessage/SuccessMessage'
import {ModalTitle} from '../../../atoms/UI/Modal/styles'
import ErrorMessage from '../../../atoms/UI/forms/ErrorMessage/ErrorMessage';
import {useTranslation} from 'react-i18next';
import {getTranslation} from '@/core/utils/i18nHelper';
import { sendReport } from '@/store/reducers/reportFormSlice';
import { AppDispatch } from '@/store/store';
import { ReportFormTypes } from '@/store/types/ReportFormTypes';

type FormTypes = {
    question_id: number | string
}

const ReportForm: React.FC<FormTypes> = ({question_id}) => {
    const dispatch: AppDispatch = useDispatch();
    const [showOnlySuccessMessage, setShowOnlySuccessMessage] = useState(false);

    const reportData = useSelector((state: any) => state.reportForm.data);
    const error = useSelector((state: any) => state.reportForm.error);
    const successMessage = useSelector((state: any) => state.reportForm.successMessage);

    const {
        register,
        handleSubmit,
        control,
        formState,
        reset,
        formState: { errors, isSubmitted, isDirty }
    } = useForm<ReportFormTypes>({
        defaultValues: reportData,
        mode: 'onTouched',
        resolver: yupResolver(schemaReportForm) as any,
    });

    useEffect(() => {
        if (successMessage) {
            reset(reportData);
            setShowOnlySuccessMessage(true);
        }
    }, [successMessage, reset, reportData]);


    const onSubmit = (data: ReportFormTypes) => {
        if (data.email === '') {
            delete data.email;
        }
        data.question_id = question_id;

        dispatch(sendReport(data));
    }

    const { t } = useTranslation();

    const text_title = t('report.title');
    const text_comment = t('report.comment');
    const text_email = t('report.email');
    const text_send = t('report.send');
    const text_mistake = t('report.mistake');
    const reportTypeOptions = getTranslation('report.type_options') as string[];

    return (
        <Grid col='1' gap='3' centeredContent>
            {showOnlySuccessMessage ? (
                <b>{successMessage}</b>
            ) : <>
                <ModalTitle>{text_title}</ModalTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid col='1' gap='4'>

                        <Grid col='1' gap='2' margin='2'>
                            <Radio
                                control={control}
                                name={'type'}
                                options={reportTypeOptions}
                                isDisabled={false}
                            />
                        </Grid>

                        <Grid col='1' gap='2' colDesktop='1'>
                            <Textarea
                                name={'comment'}
                                placeholder={text_comment}
                                register={register}
                                type='textarea'
                                error={errors.comment?.message}
                                label={text_mistake}
                                isRequired
                            />

                            <TextField
                                name={'email'}
                                placeholder={text_email}
                                register={register}
                                type='text'
                                error={errors.email?.message}
                            />

                            {successMessage && <SuccessMessage>{successMessage}</SuccessMessage>}
                            {error && <ErrorMessage>{error}</ErrorMessage>}

                            <Button type='submit' disabled={!formState.isValid}>
                                {text_send}
                            </Button>

                        </Grid>
                    </Grid>
                </form>
            </>}

        </Grid>
    )
}

export default ReportForm